import base from './Base';

function checkFieldErrors(input, errorMessage) {
    let errorState = false;
    const invalidChars = /^[^%{}\<>\\=\^]*$/gm;

    if (invalidChars.test(input.value) === false) {
        errorState = true;
    }

    else if (input.hasAttribute('required') && input.value === '') {
        errorState = true;
    }

    else if (input.hasAttribute('maxLength') && input.value.length > input.maxLength) {
        errorState = true;
    }

    else if (input.hasAttribute('minLength') && input.value.length < input.minLength) {
        errorState = true;
    }

    else if (input.type == 'number' && isNaN(input.value)) {
        errorState = true;
    }

    else {
        base.removeClass(errorMessage, 'show');
        errorState = false;
    }

    if (errorState == true) {
        event.preventDefault();
        base.addClass(errorMessage, 'show');
    }

    return errorState;
}

function checkPageValidations(input, formName) {
    let errorState = false;
    let resultContainer = document.querySelector('.results');

    if (input.type == 'text' || input.type == 'number') {

        const errorMessage = document.querySelector(`.${input.id}.error-input-container`);
        errorState = checkFieldErrors(input, errorMessage);

    } else if (input.type == 'submit') {
        const formFields = document.querySelectorAll(`#${formName} input`);

        formFields.forEach(function (field) {
            if (field.type !== 'submit') {
                const errorMessage = document.querySelector(`.${field.id}.error-input-container`);
                errorState = checkFieldErrors(field, errorMessage);
            }
        });
        if (formName) {
            if (formName === 'msl' && errorState === false) {
                displayMslData(resultContainer);
            }
        }
    }
    if (errorState === true && formName === 'msl') {
        resultContainer.innerHTML = '';
    }
}

async function displayMslData(resultContainer) {
    let mslData = await getMslData(document.querySelector('#zipAreaCode').value);
    let content = '';

    if (mslData.length) {
        mslData.forEach(msl => {
            let htmlPartial =
                `<hr class="divider" />
				<div class="msl-info">
					<span class="name">${msl.lastName}, ${msl.firstName}</span>
					<div class="row">
						<div class="col-lg-4 icon-container">
							<img src="/Content/images/src/phone-icon.svg" class="phone-icon" alt="" />
							<span class="phone"><a href="tel:${msl.phone}">${msl.phone.replace(/^(\d{3})(\d{3})(\d+)$/, "($1) $2-$3")}</a></span>
						</div>
						<div class="col-lg-8 icon-container">
							<img src="Content/images/src/email-icon.svg" class="email-icon" alt="" />
							<span class="email"><a href="mailto:${msl.email_address}"> ${msl.email_address}</a></span>
						</div>
					</div>
				</div>
                <hr class="divider" />`;

            content += htmlPartial;
            resultContainer.innerHTML = content;
        })
    } else {
        let htmlPartial = `<hr class="divider" />
							<p class="fw-bold">No results found at this time. Please try again later.<p>
                            <hr class="divider" />`;

        content = htmlPartial;
        resultContainer.innerHTML = content;
    };
}


async function getMslData(zipAreaCode) {
    const apiUrl = `https://${window.location.host}/get-msl?zipAreaCode=${zipAreaCode}`;

    try {
        let response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error(`Error! status: ${response.status}`);
        }
        return await response.json();

    } catch (error) {
        console.log(error);
    }
}

const Form = (function () {
    const inputs = base.getAll('input');
    const submitBtns = document.querySelectorAll('button[type=submit]');

    submitBtns.forEach(function (submitBtn) {
        const formName = submitBtn.getAttribute("data-target");
        submitBtn.addEventListener('click', () => { checkPageValidations(submitBtn, formName) });
    }, false);

    /* Sets event listeners on load */
    const handleEvents = () => {
        inputs.map((input) => {
            input.addEventListener('input', () => {
                checkPageValidations(input);
            });
        });
    };

    const init = () => {
        handleEvents();
    };
    return {
        init: init
    };

})();

export default Form;
